import { useContext } from "react";

import SettingsContext, {
  type SettingsContextValue,
} from "contexts/SettingsContext";

const useSettings = (): SettingsContextValue => useContext(SettingsContext);

export default useSettings;
